import { permissionGroups } from "../../pages/settings/permissionsConfig";
import { getDefaultPermissions } from "../../utils/lead-utils";
import { confirmAction } from "../../utils/utils";
import DefaultPermissions from "./DefaultPermissions";
import PermissionsGrid from "./PermissionsGrid";

type PermissionSelector = {
    permissions?: string[];
    setPermissions: (updated: string[]) => void;
    defaultPermissions: string[];
    selectedCustomer:any
};
export default function PermissionSelector({
    permissions = [],
    setPermissions = () => { },
    defaultPermissions,
    selectedCustomer
}: PermissionSelector) {

    return ( <div className="flex flex-col h-[calc(80.5vh-200px)] 2xl:h-[calc(84vh-200px)] 4xl:h-[calc(90vh-200px)]">
      
      <div className="p-3 m-3 rounded-[10px] flex-1 border border-[#EEEEEE] bg-white pb-6 overflow-y-auto custom-scroll">
        <div className=" text-[15px] font-medium text-gray-900  w-full flex justify-between !items-center border-b-[1px] border-b-[#EEEEEE] pb-1">
             <span className="flex gap-2 items-center ">
             <svg
    className="w-4 h-4"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 1.66667H9.85C9.5 0.7 8.58333 0 7.5 0C6.41667 0 5.5 0.7 5.15 1.66667H1.66667C0.75 1.66667 0 2.41667 0 3.33333V15C0 15.9167 0.75 16.6667 1.66667 16.6667H13.3333C14.25 16.6667 15 15.9167 15 15V3.33333C15 2.41667 14.25 1.66667 13.3333 1.66667ZM7.5 1.45833C7.84167 1.45833 8.125 1.74167 8.125 2.08333C8.125 2.425 7.84167 2.70833 7.5 2.70833C7.15833 2.70833 6.875 2.425 6.875 2.08333C6.875 1.74167 7.15833 1.45833 7.5 1.45833ZM5.08333 13.3333H3.33333V11.55L8.3 6.58333L10.0667 8.35L5.08333 13.3333ZM11.5417 6.89167L10.6583 7.775L8.89167 6.00833L9.775 5.125C9.94167 4.95833 10.2 4.95833 10.3667 5.125L11.5417 6.3C11.7083 6.46667 11.7083 6.725 11.5417 6.89167Z"
      fill="#007070"
    />
  </svg>
            Default Permissions
           </span>
        </div>
        <div className="  pt-0  my-3 rounded-md ">
            <DefaultPermissions permissions={getDefaultPermissions(selectedCustomer.source)}></DefaultPermissions>
            <div className=" text-[15px] font-medium text-gray-900  w-full flex justify-between !items-center border-b-[1px] border-b-[#EEEEEE] pb-1 mt-4 mb-4">
                <span className="flex gap-2 items-center ">
             <svg
    className="w-4 h-4"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 1.66667H9.85C9.5 0.7 8.58333 0 7.5 0C6.41667 0 5.5 0.7 5.15 1.66667H1.66667C0.75 1.66667 0 2.41667 0 3.33333V15C0 15.9167 0.75 16.6667 1.66667 16.6667H13.3333C14.25 16.6667 15 15.9167 15 15V3.33333C15 2.41667 14.25 1.66667 13.3333 1.66667ZM7.5 1.45833C7.84167 1.45833 8.125 1.74167 8.125 2.08333C8.125 2.425 7.84167 2.70833 7.5 2.70833C7.15833 2.70833 6.875 2.425 6.875 2.08333C6.875 1.74167 7.15833 1.45833 7.5 1.45833ZM5.08333 13.3333H3.33333V11.55L8.3 6.58333L10.0667 8.35L5.08333 13.3333ZM11.5417 6.89167L10.6583 7.775L8.89167 6.00833L9.775 5.125C9.94167 4.95833 10.2 4.95833 10.3667 5.125L11.5417 6.3C11.7083 6.46667 11.7083 6.725 11.5417 6.89167Z"
      fill="#007070"
    />
  </svg>
                Manual Permissions
            </span>
             <label className="flex !items-center space-x-2 cursor-pointer text-[14px] font-medium text-gray-900">

                <input
                    type="checkbox"
                    className="h-4 w-4 text-blue-600 rounded accent-greenBg"
                    checked={permissions.length === permissionGroups.length}
                    onChange={(e) => {
                        if (e.target.checked) {
                            confirmAction(" you want to check all permissions ", () => setPermissions(permissionGroups.map((p) => p.name)))

                        } else {
                            confirmAction(" you want to remove all permissions ", () => setPermissions([]))
                        }
                    }
                    }
                />
                <span className="text-[15px] font-medium text-gray-900">Check All </span>
            </label>
            </div>
            <PermissionsGrid
                permissions={permissions}
                setPermissions={setPermissions}
                defaultPermissions={defaultPermissions}
            ></PermissionsGrid>
        </div>
    </div>
    </div>
    )
}